import React from 'react';
import gql from 'graphql-tag';

import {
	useRoute,
} from '@react-navigation/native';
import { Screen } from '../../design/components';
import { useFreshDetailQueryOptions } from '../../hooks';

import ServiceRunDetail from './ServiceRunDetail';

const ServiceRunDetailView = () => {
	const route = useRoute();
	const id = route.params?.id;
	const {
		canRenderDetailQuery,
		detailQueryOptions,
		blockDataWhileLoading,
	} = useFreshDetailQueryOptions();

	if (!canRenderDetailQuery) {
		return <Screen isLoading={true} />;
	}

	return (
		<Screen scroll={false}>
			<ServiceRunDetail
				id={id}
				query={GET_SERVICE_RUN_NATIVE}
				detailQueryOptions={detailQueryOptions}
				blockDataWhileLoading={blockDataWhileLoading}
			/>
		</Screen>
	);
};

export default React.memo(ServiceRunDetailView);

const GET_SERVICE_RUN_NATIVE = gql`
	query($id: String) {
		getServiceRun(id: $id) {
			id
			planned
			isOneCashBag
			cashBag
			warehouse {
				id
				name
			}
			returnWarehouse {
				id
				name
			}

			route {
				id
				name
			}

			driver {
				id
				username
				firstname
				lastname
			}

			brief

			vehicle {
				id
				name
				registration
				serviceDue
			}

			serviceDockets {
				id
				status
				totalPickItemsQuantity
				date
				manualRestock
				inventoryPicked
				inventoryPartiallyPicked
				salesSinceLastRestock
				order
				cashBag
				tub
				collectCash
				cashCollected
				requirePhoto
				photoTaken
				pickList {
					id
					calculatedAt
					isAnyItemPicked
				}

				machineServiceType
				machineRestockType

				ticketList {
					id
					driverItems {
						id
						notResolved
						notResolvedComment
						ticket {
							id
							status
							visibleToDrivers
						}
					}
				}

				machine {
					id
					assetId
					type
					place {
						id
						name
					}
					machineModel {
						id
						name
					}
					machineType {
						id
						name
					}
					machineKey {
						id
						name
					}
					location {
						id
						name
						requiresAccessPass
						requiresSignIn
						signInInstructions
						addressObj {
							id
							region
							street
							city
							postcode
						}
					}
					isOffline
					hasCoinMech
					coinMech {
						id
						settings
					}
					coinMechDetail {
						tubesValueTotal
						tubesDetail {
							coinTypeNumber
							valueCoinsInTube
							numberCoinsInTube
							numberCoinsInsertedManually
							numberCoinsDispensedManually
							tubeIsFull
						}
					}
					wrap {
						name
					}
				}
			}
		}
	}
`;
